module.exports = __webpack_public_path__ + "img/mrBts_test_005_BS.32abe0a5.jpg";